import "./EcoSectiontwo.css";
import { HashLink as Link } from "react-router-hash-link";
import React, { useState, useEffect } from "react";
import Phone from "../EcoSysImages/iphone_16.png";
// import Vertical_strokes from "../EcoSysImages/Strokes-vertical.png";
import GirlPhoto from "../EcoSysImages/girl-photo.png";
import Dog from "../EcoSysImages/dog.png";
import Device from "../EcoSysImages/device.png";
import Streamer from "../EcoSysImages/streamer.png";
import ellipse_Left from "../EcoSysImages/Ellipse_Left.png";
import ellipse_Right from "../EcoSysImages/Ellipse_Right.png";

export default function EcoSectiontwo() {
  const [showCorners, setShowCorners] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowCorners(true), 400);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      className="section-two-bg"
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* <img src={Vertical_strokes} alt="" className="strokes-vertical-bg" /> */}
      <img
        src={ellipse_Left}
        alt=""
        aria-hidden="true"
        id="ellipse_left"
        className="ellipse"
      />
      <img
        src={ellipse_Right}
        alt=""
        aria-hidden="true"
        id="ellipse_right"
        className="ellipse"
      />
      <div className="section-two-container">
        <div className="section-two-content">
          <div className="step-indicator">
            <span className="step-current">02</span>
            <span className="step-total">/05</span>
          </div>
          <h1 className="section-title">Customize Your Feed</h1>
          <p className="section-desc">
            Pick a few topics you love. We'll tailor content and quests for you.
          </p>
          {/* <button className="continue-btn">Continue</button> */}
          <div className="eco-second-section-button">
            <Link to="/newfeature" onClick={() => window.scrollTo(0, 0)}>
              <div className="create-token-btn-eco">
                <p className="create-token-btn-text">Continue</p>
              </div>
            </Link>
          </div>
          <p className="section-subtext">
            Takes 10s. You can change this anytime.
          </p>
        </div>
        <div className="phone-section" style={{ position: "relative" }}>
          <img
            src={Phone}
            alt="iPhone displaying the app interface"
            className="iphone-image"
          />
          <img
            src={GirlPhoto}
            alt=""
            className={`corner-img girl-photo ${
              showCorners ? "show-corners" : ""
            }`}
          />
          <img
            src={Dog}
            alt=""
            className={`corner-img dog-photo ${
              showCorners ? "show-corners" : ""
            }`}
          />
          <img
            src={Streamer}
            alt=""
            className={`corner-img device-photo ${
              showCorners ? "show-corners" : ""
            }`}
          />
          <img
            src={Device}
            alt=""
            className={`corner-img streamer-photo ${
              showCorners ? "show-corners" : ""
            }`}
          />
        </div>
      </div>
    </section>
  );
}
